/* eslint-disable no-restricted-syntax */
export function isNil<T>(value: T): boolean {
	return value === undefined || value === null;
}

export function nonNullable<T>(value: T): value is NonNullable<T> {
	return !isNil(value);
}

type RemoveNullValues<T> = {
	[K in keyof T]: NonNullable<T[K]>;
};

export function removeNullValues<T extends Record<string, unknown>>(obj: T): RemoveNullValues<T> {
	const result = {} as RemoveNullValues<T>;
	for (const key in obj) {
		if (obj[key] !== null) {
			result[key] = obj[key];
		}
	}
	return result;
}
